import * as React from "react";
import type { SVGProps } from "react";
const SvgGrid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.167 2.5h11.666c.921 0 1.667.746 1.667 1.667v11.666c0 .921-.746 1.667-1.667 1.667H4.167c-.921 0-1.667-.746-1.667-1.667V4.167c0-.921.746-1.667 1.667-1.667"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.5 2.5v15M12.5 2.5v15"
    />
  </svg>
);
export default SvgGrid;
